import HCaptcha from "@hcaptcha/react-hcaptcha";
import { useRouter } from "next/router";
import React, { useState } from "react";

interface ContactFormProps {
  onSuccess?: () => void;
}

const ContactForm: React.FC<ContactFormProps> = ({ onSuccess }) => {
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);
  const [error, setError] = useState("");
  const router = useRouter();

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    setLoading(true);
    setError("");
    setSuccess(false);
    const form = e.target as HTMLFormElement;
    const data = {
      firstName:
        (form.elements.namedItem("firstName") as HTMLInputElement)?.value || "",
      lastName:
        (form.elements.namedItem("lastName") as HTMLInputElement)?.value || "",
      email:
        (form.elements.namedItem("email") as HTMLInputElement)?.value || "",
      phone:
        (form.elements.namedItem("phone") as HTMLInputElement)?.value || "",
      message:
        (form.elements.namedItem("message") as HTMLTextAreaElement)?.value ||
        "",
    };
    try {
      const res = await fetch("/api/contact", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(data),
      });
      if (res.ok) {
        setSuccess(true);
        form.reset();

        // Navigate to ?thanks on success
        router.push({ pathname: router.pathname, query: { thanks: "true" } });

        if (onSuccess) onSuccess();
      } else {
        const result = await res.json();
        setError(result.error || "Submission failed");
      }
    } catch {
      setError("Submission failed");
    } finally {
      setLoading(false);
    }
  };

  const handleVerificationSuccess = (token: string, ekey: string) => {
    console.log("HCaptcha verified:", token, ekey);
    // You can handle the token here if needed
  };

  return (
    <form className="sm-col-span-8 lg-col-span-4" onSubmit={handleSubmit}>
      <p>
        Please provide your contact details, and we’ll get back to you shortly
        to guide you through the final steps.
      </p>

      <input placeholder="First Name *" type="text" name="firstName" required />

      <input placeholder="Last Name *" type="text" name="lastName" required />

      <input placeholder="Your Email *" type="email" name="email" required />

      <input
        placeholder="Your Phone Number *"
        type="tel"
        name="phone"
        pattern="^\+?[0-9 \-]{7,15}$"
        inputMode="tel"
        autoComplete="tel"
        required
      />

      <HCaptcha
        sitekey={process.env.NEXT_PUBLIC_HCAPTCHA_SITE_KEY || ""}
        onVerify={(token, ekey) => handleVerificationSuccess(token, ekey)}
      />

      <button
        type="submit"
        className="w-full bg-blue-600 text-white py-2 rounded hover:bg-blue-700 transition duration-200"
        disabled={loading}
      >
        {loading ? "Submitting..." : "Submit"}
      </button>
      {success && (
        <div className="text-green-600 mt-2">
          Thank you! We will contact you soon.
        </div>
      )}
      {error && <div className="text-red-600 mt-2">{error}</div>}
      <small>
        We will solely use this information to contact you about products and
        services. By submitting this form you agree to our Privacy Policy.
      </small>
    </form>
  );
};

export default ContactForm;
